import { ValidationErrors } from "@angular/forms";
import * as momentNS from 'moment';

const moment = momentNS;

export class ValidationMessages {
  static get(errors: ValidationErrors | null): string[] {
    const messages: string[] = [];

    if (errors) {
      for(let key in errors) {
        if (errors[key]) {
          switch(key) {
            case 'required':
              messages.push('Required.');
              break;
            case 'invalidDate':
              messages.push('Not a valid date (MM/DD/YYYY).');
              break;
            default:
              if (typeof errors[key] == 'string') {
                messages.push(errors[key]);
              }
          }
        }
      }
    }
    
    return messages;
  }
}

export class CustomValidators {
  static validDate(value: any): ValidationErrors | null {
    let errors: ValidationErrors | null = null;
    const date = moment(value);
    if (!date.isValid()) {
      errors = {
        invalidDate: true
      }
    }
    return errors;
  }

  static minDate(minDate: Date, value: any): ValidationErrors | null {
    let errors: ValidationErrors | null = null;
    const date = moment(value);
    if (!date.isSameOrAfter(minDate)) {
      errors = {
        minDate: true
      }
    }
    return errors;
  }
}